import React, {Component} from 'react'
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Icon,
    TextField,
    Toolbar,
    Typography,
} from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles/index'
import {bindActionCreators} from 'redux'
import ReduxGlobal from "../../../../store/actionreducers/globalView"
import {connect} from 'react-redux'
import {constDataDialogs} from "../../../../constants"
import moment from "moment"
import ReduxNewCalender from "../../../../store/actionreducers/new-calendar"

const styles = theme => ({
    root: {},
    formControl: {
        marginBottom: 24
    },
})

class DownloadCalendar extends Component {

    state = {
        dateStart: '',
        dateEnd: '',
    }

    constructor(props) {
        super(props);
        props.setUpdateDateHandler(this.updateDate)
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.downloadCalendar})
        if (this.props.onClose) this.props.onClose()
    }

    HandleLick = link => {
        return (<Button onClick={window.open(`${link}`, '_blank')} >Download</Button>)
    }


    _download = async () => {
        try {
            const {
                closeLoadingMask,
                openLoadingMask,
                exportCalendar,
            } = this.props

            const { dateStart, dateEnd } =this.state

            openLoadingMask()
            const exportLink = await exportCalendar({dateFrom: dateStart, dateTo: dateEnd})

            // Case: 200
            this.HandleLick(exportLink.link)
            closeLoadingMask()

        } catch (e) {
            // Case Error
            const {openErrorDialog} = this.props
            if(typeof (e.error) !== "string")
                e.error = e.error.toString()
            openErrorDialog({title: e.status ? `錯誤代碼 ${e.status}` : '' , message: e.error})
            console.warn('Error = ', e)
        }
    }

    updateDate = date => {
        this.setState({
            dateStart: moment(date).startOf('month').format('YYYY-MM-DD'),
            dateEnd: moment(date).endOf('month').format('YYYY-MM-DD'),
        })
    }

    render() {
        const {classes, downloadCalendar} = this.props

        if (!downloadCalendar || downloadCalendar.props.open === false) return <div/>

        return (
            <Dialog className={classes.root} {...downloadCalendar.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            下載醫師排班表
                        </Typography>
                    </Toolbar>
                </AppBar>

                <DialogContent className="flex flex-col" classes={{root: "p-24"}}>
                    {/* display and download */}

                    <div className="flex">
                        <div className="min-w-48 pt-16">
                            <Icon color="action">today</Icon>
                        </div>
                        <div className="flex-auto">
                            <Typography className="text-12"> 今天日期 </Typography>
                            <Typography className="text-16 pb-24" > {`${moment().format('YYYY-MM-DD')}`} </Typography>
                        </div>
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20">
                            <Icon color="action">date_range</Icon>
                        </div>
                        <TextField
                            id="dateFrom"
                            name="dateFrom"
                            label="開始時間"
                            type="date"
                            className={classes.formControl}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={this.state.dateStart}
                            onChange={date => this.setState({dateStart: date.target.value})}
                        />
                    </div>

                    <div className="flex">
                        <div className="min-w-48 pt-20"/>
                        <TextField
                            id="dateTo"
                            name="dateTo"
                            label="結束時間"
                            type="date"
                            className={classes.formControl}
                            InputLabelProps={{
                                shrink: true
                            }}
                            value={this.state.dateEnd}
                            onChange={date => this.setState({dateEnd: date.target.value})}
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button variant="raised" color="secondary" onClick={() => this._download()}>下載班表</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openErrorDialog: ReduxGlobal.ActionCreator.openErrorDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
        exportCalendar: ReduxNewCalender.ActionCreator.exportCalendar,
    }, dispatch)
}

function mapStateToProps({global: {dataDialogs}}) {
    return {
        downloadCalendar: dataDialogs[constDataDialogs.name.downloadCalendar],
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(DownloadCalendar))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/newCalendar/DownloadCalendar.js